<template>
  <div class="hello flex">
    <volLeft></volLeft>
    <div class="right">
      <main>
        <schoolFilter @searchSchool='searchSchool' @clear='clear' @filter='filter' :xianding='true'></schoolFilter>
        <div class="tablehead flex">
          <span style="width: 270px;">院校名称</span>
          <span style="width: 60px;">年份</span>
          <span style="width: 90px;">招生人数</span>
          <span style="width: 70px;color: red;">预测冲</span><span style="width:70px;">预测稳</span><span
            style="width: 70px;">预测保</span><span style="width: 100px;color: orange;">实际录取分</span>
          <span style="width: 70px;color:#19CACA">线差</span>
          <span style="width: 70px;color:#19CACA">位次</span>
          <span style="margin-left: 10px;">是否替换</span>
        </div>
        <div class="tablemain flex" v-for="(item,index) in data" v-loading="loading">
          <div class="info flex" style="justify-content: flex-start;flex-wrap: nowrap;width: 270px;"
            @click="$router.push(`/schoolDetail?id=${item.school_id}`)">

            <img :src="item.badge_img" alt="">
            <div style="text-align: left">
              <div><span class="name">{{item.school_name}}</span>
              </div>
              <div class="type">
                <span style="color: orange;">{{item.cate}}</span>
                <span>{{item.type}}</span>
                <span class="address">{{item.province_name}}</span>
                <span>{{item.is_211==1?'211':''}}</span>
                <span>{{item.is_985==1?'985':''}}</span>
                <span> {{item.is_211==1&&item.is_985==1?'双一流':''}}</span>
              </div>
              <div class="type" style="font-size: 13px;">招生代码：{{item.enroll_code}}</div>
            </div>
          </div>
          <div class="" style="width: 60px;">
            <div v-for="(item,index) in item.history" style="display: block;
          margin: 5px auto;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;">
              {{item.year}}
            </div>
          </div>
          <div class="" style="width: 90px;">
            <div v-for="(item1,index1) in item.history" style="display: block;
          margin: 5px auto;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;">
              {{index1==0&&item1.enroll_plan!=null?item1.enroll_plan:'-'}}
            </div>
          </div>

          <div class="history" style="width: 70px;color: red;">
            <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
              <span style="flex:1;text-align: center;">{{item1.score_pre_div==0?'-':item1.score_pre_div}}
              </span>
            </div>
            <div v-else>
              暂无数据
            </div>
          </div>

          <div class="history" style="width: 70px;">
            <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
              <span style="flex:1;text-align: center;">{{item1.score_add_avg==0?'-':item1.score_add_avg}}
              </span>
            </div>
            <div v-else>
              暂无数据
            </div>
          </div>
          <div class="history" style="width: 70px;">
            <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
              <span style="flex:1;text-align: center;">{{item1.score_add_div==0?'-':item1.score_add_div}}
              </span>
            </div>
            <div v-else>
              暂无数据
            </div>
          </div>
          <div class="history" style="width: 100px;color: orange;">
            <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
              <span style="flex:1;text-align: center;">{{item1.score_actual==0?'-':item1.score_actual}}
              </span>
            </div>
            <div v-else>
              暂无数据
            </div>
          </div>
          <div style="color:#19CACA;width:70px;" target="_blank">
            <div v-for="(item1,index) in item.history" style="display: block;
          margin: 5px auto;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;">
              {{item1.score_actual!=null&&item.province_line!=null&&item1.score_actual!=0?item1.score_actual-item1.province_line:'---'}}
            </div>
          </div>
          <div style="color:#19CACA;width:70px;" target="_blank">
            <div v-for="(item1,index) in item.history" style="display: block;
          margin: 5px auto;
          height: 24px;
          line-height: 24px;
          text-align: center;">
              {{item1.score_rank==null||item1.score_rank==0?'---':item1.score_rank}}
            </div>
          </div>
          <div style="margin-left: 10px;">
            <div class="btn" style="cursor: pointer;" @click="changeschool(item)">
              替换
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- 遮罩层 -->
    <div id="mask" ref="mask" v-show="dialogTableVisible">
      <popup :show='dialogTableVisible'></popup>
    </div>
    <div id="mask" ref="mask" v-show="popupshow">

    </div>
  </div>
</template>

<script>
  import popup from '../../components/popup.vue'
  import schoolFilter from '../../components/schoolfilter.vue'
  import volLeft from '../../components/volLeft.vue'
  export default {
    data() {
      return {
        record: [],
        popupshow: false,
        tabindex: 0,
        formInline: {
          user: '',
          region: ''
        },
        data: [],
        page: 1,
        current: 0,
        activeName: 'first',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        radio: 2,
        userInfo: [],
        options: [],
        batch: '',
        cache_id: '',
        loading: false,
        school_id: '',
        school_pos: '',
        school: [],
        tableData: [],
        tableList: [],
        checkedSchool: [],
        popover_content: '',
        zhuanye: [],
        checkedId: [],
        old: [], //最开始的数据
        one_major: [],
        type: 'danger'
      }
    },
    components: {
      popup,
      schoolFilter,
      volLeft
    },
    created() {
      if (localStorage.getItem('userInfo')) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      } else {
        this.$message.warning('请先登录')
        this.$store.commit('login', true)
      }
      this.$http.aiSchoolList({
        cache_id: this.$route.query.cache_id,
        mode: this.$route.query.mode == '' ? 'danger' : this.$route.query.mode
      }).then(res => {
        this.data = res.data.list
        this.data.forEach(item => {
          item.history.unshift({
            'score_actual': item.score_actual,
            'score_add_avg': item.score_add_avg,
            'score_add_div': item.score_add_div,
            'score_pre_div': item.score_pre_div,
            'year': item.year,
            "province_line": item.province_line,
            'score_rank': item.score_rank,
            'enroll_plan': item.enroll_plan
          })
          item.check_result = this.type
        })
        this.old = res.data.list
      })
    },
    methods: {
      /* 替换学校*/
      changeschool(item) {
        if (this.type == '') {
          item.check_result = 'danger'
        } else {
          item.check_result = this.type
        }
        let school = item
        school.history.shift()

        this.$http.aiChange({
          cache_id: this.$route.query.cache_id,
          change_id: this.$route.query.change_id,
          school: school
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('替换成功')
            this.$router.push(`/ai?cache_id=${this.$route.query.cache_id}`)
          }
        })
      },
      /* 保存志愿，获取结果*/
      saveAll() {
        this.$http.checkSchool({
          cache_id: this.cache_id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功')
            this.$router.push(`/form?id=${this.cache_id}`)
          }
        })
      },
      editor(item) {
        this.cache_id = item._id.$oid
        this.$http.customCheckDetail({
          cache_id: this.cache_id
        }).then(res => {
          res.data.result.map(item => {
            this.checkedId.push(item.school_id)
          })
          this.checkedSchool = res.data.result
          this.$http.checkSchoolCustomSearch({
            cache_id: this.cache_id
          }).then(res => {
            this.data = res.data.list
            this.old = res.data.list
            this.data.forEach(item => {
              item.checked = false
            })
          })
          this.add = false
          this.$forceUpdate()
        })
      },
      del(item) {

        this.$http.del({
          cache_id: item._id.$oid
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.$http.customCheckList().then(res => {
              this.record = res.data.list
            })
          }
        })
      },
      /* 添加新志愿*/
      addnew() {
        this.add = true
        this.dialogTableVisible1 = true
      },
      /* 筛选学校*/
      filter(e) {

        this.type = e.cwb
        /* 地区*/
        if (e.num == 1) {
          if (e.diqu.length == 0) {
            this.data = this.old
            return
          }
          let result = []
          for (let i = 0; i < e.diqu.length; i++) {
            for (let o = 0; o < this.old.length; o++) {
              console.log(e.diqu[i], this.old[o].province_id)
              if (e.diqu[i] == this.old[o].province_id) {
                result.push(this.old[o])
              }
            }
          }
          this.data = result

        }
        /* 办学类型 公办民办*/
        if (e.num == 2) {
          if (e.type == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.type == e.type
            })
          }
        }
        /* 985*/
        if (e.num == 3) {
          if (e.is985 == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.is_985 == e.is985
            })
          }
        }
        if (e.num == 4) {
          if (e.is211 == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.is_211 == e.is211
            })
          }
        }
        if (e.num == 5) {
          this.data = this.data.filter(item => {
            return item.category_id == e.category_id
          })
        }
        // 选择冲稳保
        if (e.num == 6) {
          this.$http.aiSchoolList({
            cache_id: this.$route.query.cache_id,
            mode: e.cwb
          }).then(res => {
            this.data = res.data.list
            this.data.forEach(item => {
              item.history.unshift({
                'score_actual': item.score_actual,
                'score_add_avg': item.score_add_avg,
                'score_add_div': item.score_add_div,
                'score_pre_div': item.score_pre_div,
                'year': item.year,
                "province_line": item.province_line,
                'score_rank': item.score_rank,
                'enroll_plan': item.enroll_plan
              })
              item.check_result = this.type
            })
            this.old = res.data.list
          })
        }
      },
      /* 搜索学校*/
      searchSchool(e) {

        let result = this.old.filter(item => {

          return item.school_name.indexOf(e + '') > -1
        })
        this.data = result
      },
      /* 清空搜索条件*/
      clear() {
        this.data = this.old
      },
      /* 保存选完专业的学校*/
      savezhuanye() {
        // let result = this.tableList.filter(item => {
        //   return item.checked == true
        // })
        let data = {
          major: this.one_major,
          school_pos: this.school_pos,
          cache_id: this.cache_id
        }


        if (this.zhuanye.length > 5) {
          this.$message.error('最多可填5个专业!')
          return
        }
        this.$http.aiMajorChange(data).then(res => {
          if (res.code == 200) {
            this.$message.success('保存成功!')
            this.popupshow = false
            this.tableList = []
            this.tableData = []
          }
        })
        this.$http.customCheckDetail({
          cache_id: this.cache_id
        }).then(res => {
          this.checkedSchool = res.data.result
          this.$forceUpdate()
        })
      },
      tianbaozhuanye(item) {

        if (this.zhuanye.length == 5 && item.checked == false) {
          this.$message.error('最多只能填写五个专业！')
          return
        }
        item.checked = !item.checked
        if (this.zhuanye.indexOf(item.mid) > -1) {
          this.zhuanye.splice(this.zhuanye.indexOf((item.mid)), 1)
          this.one_major.splice(this.zhuanye.indexOf((item.mid)), 1)
        } else {
          this.zhuanye.push(item.mid)
          this.one_major.push(item)
        }
        // this.$forceUpdate()
      },
      //查看招生计划
      lookplan(item) {
        this.$http.schoolEnrollPlan({
          major_name: item.major_name,
          school_id: this.school_id
        }).then(res => {
          this.popover_content = res.data.list[0].year + res.data.list[0].major_name + ';招生人数:' + res.data.list[0]
            .num + '费用:' + res.data.list[0].money_year +
            '说明:' + res.data.list[0].major_detail
        })
      },
      /* 切换专业历史录取的年份 */
      tabchange(item, index) {
        let data = {
          cache_id: this.cache_id,
          school_id: this.school_id,
          year: item.label
        }
        this.tableList = []
        this.$http.checkMajorCustomSearch(data).then(res => {
          this.tableList = res.data.list
          // this.tableList = res.data.list.map(item => {
          //   return item.checked == false
          // })
          this.tabindex = index
          // this.$forceUpdate()
        })
      },
      /* 点击填报学校*/
      tianbao(item, index) {
        this.$http.aiChange({
          cache_id: this.$route.query.cache_i,
          change_id: this.checkedSchool.length,
          school: item
        }).then(res => {
          this.checkedId.push(item.school_id)
          this.$http.customCheckDetail({
            cache_id: this.cache_id
          }).then(res => {
            this.school_pos = res.data.result.length
          })
        })
      },
      change() {
        this.dialogTableVisible = true
      },
      check(item) {
        this.batch = item.name
        this.options.forEach(item1 => {
          item1.checked = false
        })
        item.checked = true
      },
      sure() {
        if (this.batch == '') {
          this.$message.warning('请先选择批次')
          return
        }
        this.$http.customSchoolNew({
          batch: this.batch
        }).then(res => {
          this.cache_id = res.data.cache_id
          this.dialogTableVisible1 = false
          this.add = false
          this.$http.checkSchoolCustomSearch({
            cache_id: this.cache_id
          }).then(res => {
            this.data = res.data.list
            this.old = res.data.list
            this.data.forEach(item => {
              item.checked = false
            })
          })
          this.$http.customCheckDetail({
            cache_id: this.cache_id
          }).then(res => {
            this.school_pos = res.data.result.length
            this.checkedSchool = this.data.map(item => {
              return item.school_id
            })
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #E8FAFA;
    border: 1px solid #19CACA;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    text-align: center;
    cursor: pointer;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #19CACA;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -228px;

    button {
      width: 100px;
      height: 40px;
      background: #19CACA;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #19CACA;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .current {
    width: 324px;
    height: 39px;
    line-height: 39px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #FA6002;

    span {
      display: inline-block;
    }

    .dangqian {
      width: 236px;
    }

    .change {
      display: inline-block;
      width: 81px;
      height: 39px;
      background: #FF6500;
      border-radius: 10px;
      color: #ffffff;
    }
  }

  #mask {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 998;
    height: 100vh;
  }

  .tablemain {
    // justify-content: center;

    &>div {
      // flex: 1;
      text-align: center;
    }

    border-bottom: 1px solid #F2F2F2;
    padding: 18px 0;

    .shuju span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: rgba(207, 202, 204, 0.1);
      border: 1px solid #B0B0B0;
      color: #B0B0B0;
      border-radius: 5px;
    }

    .shuju1 span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border: 1px solid transparent;
      text-align: center;
      border-radius: 5px;
    }

    .btn {
      width: 74px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      background: #19CACA;
      border-radius: 4px;
    }

    .info {

      text-align: center;

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 15px;
      }
    }
  }

  .tablehead {
    // width: 979px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    margin-top: 20px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
    }

    // & span:nth-child(2) {
    //   flex: 3
    // }

    // & span:nth-child(3) {
    //   flex: 2
    // }
  }

  main {
    // margin-top: 51px;

    .choosetype {
      text-align: left;

      .active {
        font-weight: 400;
        color: #19CACA;
        background: #D1F4F4;
      }

      span {
        display: inline-block;
        width: 107px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #F2F2F2;
        border-radius: 4px 0px 0px 0px;
        text-align: center;
      }
    }
  }

  .filter1 {
    justify-content: space-around;
    margin: 29px 20px;
  }

  .filter2 {
    justify-content: space-between;

    .clear {
      width: 60px;
      height: 36px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      color: #19CACA;
      background-color: #ffffff;
      color: #19CACA !important;
    }

    .flex {
      flex-wrap: nowrap;

      span {
        width: 100px
      }
    }

    margin: 0px 20px;
  }

  .right {
    margin-left: 16px;
  }

  .filter {
    // width: 979px;
    height: 149px;
    border: 1px solid #EDEDED;
    border-radius: 10px;
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #19CACA
  }

  .line {
    margin: 25px 0 18px 0;
    color: #19CACA
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #19CACA;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #19CACA;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .active {
    background: #19CACA;
    color: #FFFFFF;

  }

  .tabactive {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    border-bottom: 1px solid #19CACA;
  }

  .type {
    margin-top: 22px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;
    line-height: 20px;

    span {
      margin: 0 5px;
    }
  }

  .name {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .address {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 10px;
  }

  .popuptitle {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E6E6E6;
    text-indent: 40px;
  }

  .popup2 {
    width: 800px;
    height: 654px;
    background: #e8ffc9;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -327px;
    overflow: hidden;
  }

  .caozuo {
    margin-top: 30px;
  }

  .popup1 {
    width: 990px;
    padding-bottom: 40px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -495px;
    margin-top: -327px;
    overflow: hidden;
    z-index: 999;
  }

  .tableHead1 {
    width: 925px;
    margin: 0 auto;
    height: 40px;
    background: #FAFAFA;
    border-radius: 4px;
    line-height: 40px;

  }

  .tableHead1 span {
    width: 120px;
    color: #999999;
  }

  .table1 {
    width: 100%;
    justify-content: space-around;
    margin-top: 40px;
  }

  .tableHead {
    margin-top: 40px;
    justify-content: space-between;
  }
</style>
<style lang="scss">
  // 添加颜色类
  .el-radio__input.is-checked+.el-radio__label {
    color: #19CACA !important;
    font-size: 16px
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #19CACA !important;
    border-color: #19CACA !important;
    font-size: 16px
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/aiChange.vue